import { orderBy } from 'lodash';

export default class CoreUtils {
  static isUndefinedOrNull(value) {
    return (value === undefined || value === null)
  }

  static isDefinedAndNotNull(value) {
    return (value !== undefined && value !== null)
  }

  static iterateProperties(object, iteratorMethod) {
    if (CoreUtils.isUndefinedOrNull(object))
      return;

    for (var fieldName in object)
      iteratorMethod(fieldName, object[fieldName]);
  }

  static getObjectPropertyNames(object) {
    if (CoreUtils.isUndefinedOrNull(object))
      return null;

    var propertyNames = [];
    for (var fieldName in object)
      propertyNames.push(fieldName);

    return orderBy(propertyNames);
  }

  static getPropertyCount(object) {
    if (CoreUtils.isUndefinedOrNull(object))
      return undefined;

    var count = 0;
    for (var _ in object)
      count += 1;

    return count;
  }

  static areValuesEquivalent(value1, value2) {
    const objectType = 'object';

    if (CoreUtils.isUndefinedOrNull(value1) && CoreUtils.isUndefinedOrNull(value2))
      return true;

    if (CoreUtils.isUndefinedOrNull(value1) || CoreUtils.isUndefinedOrNull(value2))
      return false;

    if (Array.isArray(value1) && Array.isArray(value2))
      return this.areArraysEquivalent(value1, value2);

    if (Array.isArray(value1) || Array.isArray(value2))
      return false;

    var value1Type = typeof value1;
    var value2Type = typeof value2;

    if (value1Type === objectType && value2Type === objectType)
      return this.areObjectsEquivalent(value1, value2);

    if (value1Type === objectType || value2Type === objectType)
      return false;

    return value1 === value2;
  }

  static areArraysEquivalent(array1, array2) {
    if (array1.length !== array2.length)
      return false;

    for (var index = 0; index < array1.length; index++) {
      if (!CoreUtils.areValuesEquivalent(array1[index], array2[index]))
        return false;
    }

    return true;
  }

  static areObjectsEquivalent(object1, object2) {
    var propertyNames1 = CoreUtils.getObjectPropertyNames(object1);
    var propertyNames2 = CoreUtils.getObjectPropertyNames(object2);

    if (!CoreUtils.areArraysEquivalent(propertyNames1, propertyNames2))
      return false;

    for (var index = 0; index < propertyNames1.length; index++) {
      var propertyName = propertyNames1[index]
      if (!CoreUtils.areValuesEquivalent(object1[propertyName], object2[propertyName]))
        return false;
    }

    return true;
  }
}